import { Chip } from '@/components/ui/chip'
import { CrmIcon } from './CrmIcon'

export interface CategoryLike {
  name: string
  color: string
  icon: string
}

/** A category: tinted rectangle with its icon (ED-13). */
export function CategoryChip({
  category,
  size = 'sm',
  className,
}: {
  category: CategoryLike
  size?: 'sm' | 'md'
  className?: string
}) {
  return (
    <Chip
      color={category.color}
      shape="tag"
      size={size}
      icon={<CrmIcon name={category.icon} />}
      className={className}
    >
      {category.name}
    </Chip>
  )
}
